import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import { useReCaptcha } from '@/providers/recaptcha';
import IconGoogle from '@scramble/design-system/icons/social/google.svg';
import { Button } from '@scramble/ui';
import config from '@/config';
import s from './index.module.scss';

export const GoogleButton = props => (
  <GoogleOAuthProvider clientId={config.googleAppId}>
    <StyledButton {...props} />
  </GoogleOAuthProvider>
);

const StyledButton = props => {
  const { loaded, getCaptchaToken } = useReCaptcha();
  const { label, onGoogleResponseSuccess, onGoogleResponseFailure } = props;

  const login = useGoogleLogin({
    onSuccess: onGoogleResponseSuccess,
    onError: onGoogleResponseFailure,
  });

  const handleClick = async () => {
    if (loaded) {
      const token = await getCaptchaToken();
      token && login();
    }
  };

  return (
    <Button
      theme="neutral"
      appearance="tonal"
      className={s.button}
      onClick={handleClick}
    >
      <img src={IconGoogle} width={24} height={24} alt="Google" />
      <span className="f-body-md f-500">{label}</span>
    </Button>
  );
};
